(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restore-remain-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rr-needs button').forEach((button)=>{button.addEventListener('click',()=>{document.querySelectorAll('.rr-needs button').forEach((item)=>item.classList.remove('is-active'));button.classList.add('is-active');const field=document.querySelector('#rr-support-message');field.value=button.dataset.message;field.focus()})});const copyButton=document.querySelector('.rr-copy');if(copyButton){copyButton.addEventListener('click',async()=>{const field=document.querySelector('#rr-support-message');const status=document.querySelector('.rr-copy-status');if(!field.value){status.textContent='Choose the support you need first.';return}try{await navigator.clipboard.writeText(field.value);status.textContent='Message copied. You can paste it into a text or email.'}catch(error){field.select();status.textContent='Your message is selected and ready to copy.'}})}document.querySelectorAll('.rr-mobile-links a').forEach((link)=>link.addEventListener('click',()=>{const menu=document.querySelector('.rr-mobile-menu');if(menu)menu.open=false}));

  } catch(e) { console.error(e); }
})();
})();
